<template>
  <div>
    <div class="d-flex p-1 justify-content-between flex-row">
      <div class="d-flex justify-content-center flex-row align-items-center pl-35">
        <div class="mb-1 mb-md-0 d-flex align-items-center mr-2">
          <span class="text-muted small" v-if="totalRecords">{{ totalRecords }} Items</span>
        </div>
        <div>
          <v-select :options="paginationOptions.perPageDropdown" v-model="params.per_page"
                    @input="getTableData"
                    :clearable="false">
          </v-select>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-row align-items-center">
        <div class="mr-2">
          <b-pagination
            v-model="params.page"
            :total-rows="totalRecords"
            :per-page="params.per_page"
            align="right"
            pills
            size="sm"
            class="my-0"
            first-number
            last-number
            @input="getTableData"
          >
            <template #next-text>
              <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
            </template>
            <template #prev-text>
              <chevron-left-icon size="1x" class="custom-class"></chevron-left-icon>
            </template>
            <template #first-text><span class="text-success">First</span></template>
            <template #last-text><span class="text-info">Last</span></template>
          </b-pagination>
        </div>
        <div class="ml-2">
          <div class="d-flex flex-row justify-content-end">
            <b-form-input @keyup.enter="goToPage()" v-model="movingPage" type="text" class="mr-2 go-to-btn justify-content-end"></b-form-input>
            <b-button variant="primary" @click="goToPage()">go</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon, ChevronLeftIcon } from 'vue-feather-icons'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'pagination-controls',
  props: ['paginationOptions', 'totalRecords', 'movingPage', 'rows', 'params'],
  components: { ChevronRightIcon, ChevronLeftIcon },
  methods: {
    getTableData() {
      this.movingPage = this.params.page
      this.$emit('get-table-data', this.params.page)
    },
    goToPage() {
      this.params.page = this.movingPage
      this.getTableData()
    }
  }
}
</script>

<style scoped>
::v-deep .v-select div div input.vs__search {
  border: none !important;
}

.pl-35 {
  padding-left: 1.1rem !important;
}
</style>
